import PropTypes from "prop-types";
import { useState } from "react";
import { resolveImage } from "../cart-redesign/pricing";

/*
 * The photos uploaded with the claim. Their paths are stored as multer wrote
 * them, but the API does not serve the uploads folder, so an image that
 * can't load is dropped — and if none of them resolve the card says so
 * rather than showing a row of empty tiles.
 */
const EvidenceGallery = ({ images }) => {
  const [broken, setBroken] = useState([]);

  const markBroken = (image) =>
    setBroken((current) =>
      current.includes(image) ? current : [...current, image]
    );

  const visible = images.filter((image) => !broken.includes(image));

  return (
    <section className="c4rtn__card" aria-labelledby="c4rtn-evidence-heading">
      <h2 className="c4rtn__card-title" id="c4rtn-evidence-heading">
        Photos You Supplied ({images.length})
      </h2>

      {visible.length ? (
        <ul className="c4rtn__gallery">
          {visible.map((image) => (
            <li className="c4rtn__gallery-item" key={image}>
              <a href={resolveImage(image)} target="_blank" rel="noreferrer">
                {/* Not lazy: these need to resolve (or fail) up front so the
                    card can fall back to the note below. */}
                <img
                  src={resolveImage(image)}
                  alt="Return evidence"
                  onError={() => markBroken(image)}
                />
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <p className="c4rtn__note">
          {images.length} photo{images.length === 1 ? "" : "s"} came in with this
          request and our returns team can see {images.length === 1 ? "it" : "them"}
          , but {images.length === 1 ? "it isn't" : "they aren't"} available to
          preview here.
        </p>
      )}
    </section>
  );
};

EvidenceGallery.propTypes = {
  images: PropTypes.array.isRequired,
};

export default EvidenceGallery;
